import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormularioMantenimientoComponent } from './formulario-mantenimiento/formulario-mantenimiento.component';

@Component({
  selector: 'app-listado-mantenimientos',
  templateUrl: './listado-mantenimientos.component.html',
  styleUrls: ['./listado-mantenimientos.component.scss']
})
export class ListadoMantenimientosComponent implements OnInit {
    
    public usar_renta:boolean=false;
    public mantenimiento: any= {
        intereses_moratorios: [],
        incremento_inpc: false,
        activo: true,
        periodicidad: {}
    };
    public loading:boolean=false;
    public errors:any=[];
    @Input() public contrato: any = {};

    @ViewChild(FormularioMantenimientoComponent) formulario_mantenimiento:FormularioMantenimientoComponent;
    @Output() contratoGuardado: EventEmitter<any> = new EventEmitter;

    public mantenimientos_backup:any[]=[];

    constructor() {
    }

    ngOnInit() {
    }

    defaultMantenimiento(){
        return {
            intereses_moratorios: [],
            incremento_inpc: false,
            activo: true,
            periodicidad: "MENSUAL"
        };
    }

    loadMantenimiento(mantenimiento){
        this.mantenimiento = mantenimiento;
        var parent = this;
        setTimeout(function(){
            parent.formulario_mantenimiento.loadMantenimiento(mantenimiento);
        },500);
    }

    guardarMantenimiento($event){
        var mtto_recibida = $event;
        if(mtto_recibida.id_mantenimiento && mtto_recibida.id_mantenimiento!=0){
            for(var i=0;i<this.contrato.mantenimientos.length;i++){
                var r = this.contrato.mantenimientos[i];
                if(r.id_mantenimiento==mtto_recibida.id_mantenimiento){
                    this.contrato.mantenimientos[i] = mtto_recibida;
                }
            }
        }else{
            this.contrato.mantenimientos.push($event);
        }
        this.guardarContrato(false);
    }

    guardarContrato(go_to_next_page){
        if(!this.validar()) return false;
        this.loading = true;
        var parent = this;
        if(this.contratoGuardado){
          this.contratoGuardado.emit(
              {
                  go_to_next_page:go_to_next_page,
                  contrato:this.contrato,
                  callback: function(){
                    parent.loading = false;
                    parent.nuevoMantenimiento();
                  }
                });
        }
      }

    validar(){
        var valid = true;
        this.errors = [];
        if(this.contrato.rentas.length==0){
            valid = false;
            this.errors['rentas']="Por favor dé de alta uno o más mantenimientos";
        }
        return valid;
    }

    nuevoMantenimiento(){
        this.mantenimiento = this.defaultMantenimiento();
        var parent = this;
        setTimeout(function(){
            parent.formulario_mantenimiento.loadMantenimiento(parent.mantenimiento);
        },500);
    }

    changeUsarRenta(){
        if(this.usar_renta){
            this.mantenimientos_backup = this.contrato.mantenimientos;
            this.contrato.mantenimientos = this.copiarDesdeRenta();
            this.guardarContrato(false);
        }else{
            this.contrato.mantenimientos = this.mantenimientos_backup;
            this.nuevoMantenimiento();
        }
    }

    eliminarMantenimiento(index){
        if(confirm("¿Estás seguro que deseas eliminar este mantenimiento?")){
            for(var i=0;i<this.contrato.mantenimientos.length;i++){
                if(index==i){
                    this.contrato.mantenimientos.splice(i,1);
                }
            }
            this.guardarContrato(false);
        }
    }

    copiarDesdeRenta(){
        var mttos = [];
        for(var i=0;i<this.contrato.rentas.length;i++){
            var renta = this.contrato.rentas[i];
            var im = [];
            for(var j=0; j<renta.intereses_moratorios.length;j++){
                var renta_im = renta.intereses_moratorios[j];
                im.push(
                    {
                        incremento_porcentual: renta_im.incremento_porcentual,
                        cantidad: renta_im.cantidad,
                        unidad: renta_im.unidad,
                        activo: renta_im.activo
                    }
                );
            }
            mttos.push(
                {
                    importe: 0,
                    moneda: renta.moneda,
                    notas: renta.notas,
                    fecha_inicio: renta.fecha_inicio,
                    fecha_fin: renta.fecha_fin,
                    incremento_inpc: renta.incremento_inpc,
                    puntos_inpc_renovacion: renta.puntos_inpc_renovacion,
                    periodicidad: renta.periodicidad,
                    activo: renta.activo,
                    intereses_moratorios: im
                }
            );
        }
        return mttos;
    }

    loadContrato(){
        var parent = this;
        setTimeout(function(){
            parent.formulario_mantenimiento.loadContrato();
        },500);
    }

}


// WEBPACK FOOTER //
// ./src/app/components/contratos/agregar-contrato/listado-mantenimientos/listado-mantenimientos.component.ts